import TableTicketData from './components/TableTicketData';

const Tickets = () => {
  return <TableTicketData />;
};

export default Tickets;
